import React from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { dateFormat, isValue, weekOptions } from "../../../../../utils/constants/constants";
const ShopSettings = ({ activeStep }) => {
  const shop = useSelector((state) => state.addShop);
  const form2Details = shop?.form2Options;
  const form3Details = shop?.form3Options;
  const source = useSelector((state) => state.source.sourceDatas);
  const { flyFrom, flyTo } = shop?.addFlightShop;
  const form1Details = shop?.form1Options;
  const brands = source?.carrier?.filter(data => form1Details?.brands?.includes(data?.code))?.map(dt => dt?.source);
  const gds = source?.source?.filter(data => (form1Details?.gds?.includes(data?.code) && data?.sourceType === "GDS"))?.map(dt => dt?.source)
  const OTAs = source?.source?.filter(data => (form1Details?.ota?.includes(data?.code) && data?.sourceType === "OTA"))?.map(dt => dt?.source)
  const otherSources = source?.source?.filter(data => (form1Details?.meta?.includes(data?.code) && data?.sourceType !== "OTA"))?.map(dt => dt?.source)


  //call-count
  const sourceLength = [...form1Details?.brands, ...form1Details?.gds, ...form1Details?.ota, ...form1Details?.meta, ...form1Details?.yourAirline].filter(
    item => item !== 0 && item !== "0"
  ).length;
  const routeVal = form2Details?.route === "RT" ? 2 : 1;
  const horizonVal = (form2Details?.horizonDays.length ? form2Details?.horizonDays.reduce((sum, range) => {
    const [start, end] = range.split('-').map(Number);
    return sum + ((end - start) + 1);
  }, 0) : 0
  ) +
    (form2Details?.startDate && form2Details?.startDate !== null && form2Details?.endDate && form2Details?.endDate !== null ? (Math.ceil(Math.abs(new Date(form2Details?.endDate) - new Date(form2Details?.startDate)) / (1000 * 60 * 60 * 24))) + 1 : 0)
    +
    (form2Details?.customDay && form2Details?.customDay?.length ? form2Details?.customDay.split(",").map(v => v.trim()).filter(v => v !== "").length : 0);
  const frequencyVal = (form3Details?.frequency === "Daily" ? 30 : 0)
    +
    (form3Details?.frequency === "Weekly" ? form3Details?.weekDays?.length * 4.32 : 0)
    +
    (form3Details?.frequency === "Monthly" ? form3Details?.monthDaysAdd?.length : 0)
    +
    (form3Details?.frequency === "Custom" ? form3Details?.customAdd.reduce((sum, item) => {
      if (typeof (item) === "number") {
        return sum + 1;
      } else {
        return sum + (item.split("/")[0].split(",")?.length);
      }
    }, 0) : 0);
  const scheduleVal = form3Details?.deliveryzone?.length
  const callCount = Number(
    Number(1 * //market
      sourceLength  // source
      * 1 * 1 * 1 * // Cabin class, PAX, POC
      (routeVal ? routeVal : 1) *
      1 * //currency 
      (horizonVal ? horizonVal : 1) // horizon
      * (frequencyVal ? frequencyVal : 1) * // frequency
      (scheduleVal ? scheduleVal : 1) // schedule
    ).toFixed(3)
  )

  return (
    <>
      {/* form 1 */}
      {flyFrom && flyTo && (
        <h5>
          <span className="detailslabel">Market :</span>
          <span className="labelvalue">
            {flyFrom.includes("-") && flyTo?.includes("-") ? `${flyFrom?.split(" - ")?.[1]} - ${flyTo?.split(" - ")?.[1]}` : `${flyFrom}- ${flyTo}`}
          </span>
        </h5>
      )}
      {/* Deepsearch feature disabled for now
      <h5>
        <span className="detailslabel">Deepsearch :</span>
        <span className="labelvalue">
          {form1Details?.isDeepsearch?.includes?.("yes") || form1Details?.isDeepsearch?.includes?.("Yes") || form1Details?.isDeepsearch === true ? "Yes" : "No"}
        </span>
      </h5>
      */}
      {activeStep === 0 ? (
        <>
          {/* Brands.com */}
          {brands?.length > 0 && (
            <h5>
              <span className="detailslabel">Brands.com :</span>
              <span className="labelvalue">
                {brands?.map((brand) => `${brand}`)?.sort()?.join(", ")}
              </span>
            </h5>
          )}
          {/* GDS */}
          {gds?.length > 0 && (
            <h5>
              <span className="detailslabel"> GDS :</span>
              <span className="labelvalue">
                {[...new Set(gds)]?.map((ota) => `${ota}`)?.sort()?.join(", ")}
              </span>
            </h5>
          )}
          {/* OTSs */}
          {OTAs?.length > 0 && (
            <h5>
              <span className="detailslabel"> OTAs :</span>
              <span className="labelvalue">
                {[...new Set(OTAs)]?.map((ota) => `${ota}`)?.sort()?.join(", ")}
              </span>
            </h5>
          )}
          {/* Fares */}
          <h5>
            <span className="detailslabel">Fares :</span>
            <span className="labelvalue">{form1Details?.isAncillary.includes("yes") || form1Details?.isAncillary.includes("Yes") ? "Ancillaries" : "Regular"}</span>
          </h5>
          {/* MetaSources */}
          {otherSources?.length > 0 && (
            <h5>
              <span className="detailslabel"> MetaSources :</span>
              <span className="labelvalue">
                {[...new Set(otherSources)]?.map((ota) => `${ota}`)?.sort()?.join(", ")}
              </span>
            </h5>
          )}
        </>
      ) : ""}
      {activeStep !== 0 ? (
        <>
          {/* Brands.com */}
          {brands?.length > 0 && (
            <h5>
              <span className="detailslabel">Brands.com :</span>
              <span className="labelvalue">
                {brands?.map((brand) => `${brand}`).sort().join(", ")}
              </span>
            </h5>
          )}
          {/* GDS */}
          {gds?.length > 0 && (
            <h5>
              <span className="detailslabel"> GDS :</span>
              <span className="labelvalue">
                {gds?.map((ota) => `${ota}`).sort().join(", ")}
              </span>
            </h5>
          )}
          {/* OTAs */}
          {OTAs?.length > 0 && (
            <h5>
              <span className="detailslabel"> OTAs :</span>
              <span className="labelvalue">
                {OTAs?.map((ota) => `${ota}`).sort().join(", ")}
              </span>
            </h5>
          )}
          {/* Fares */}
          <h5>
            <span className="detailslabel">Fares :</span>
            <span className="labelvalue">{form1Details?.isAncillary.includes("yes") || form1Details?.isAncillary.includes("Yes") ? "Ancillaries" : "Regular"}</span>
          </h5>
          {/* MetaSources */}
          {otherSources?.length > 0 && (
            <h5>
              <span className="detailslabel"> MetaSources :</span>
              <span className="labelvalue">
                {otherSources?.map((ota) => `${ota}`).sort().join(", ")}
              </span>
            </h5>
          )}
        </>
      ) : ""}
      {/* form 2 */}
      {/* Route Type */}
      {form2Details?.route ? (
        <h5>
          <span className="detailslabel">Route Type :</span>
          <span className="labelvalue">
            {form2Details?.route === "OW" ? "One Way" : "Round Trip"}
          </span>
        </h5>
      ) : ""}

      {/* LOS */}
      {form2Details?.route === "RT" ? (
        <h5>
          <span className="detailslabel">LOS :</span>
          <span className="labelvalue">
            {form2Details?.los !== undefined && form2Details?.los !== null && String(form2Details.los).trim() !== ""
              ? (() => {
                  const losArray = Array.isArray(form2Details.los)
                    ? form2Details.los
                    : String(form2Details.los).split(",").map((s) => s.trim()).filter(Boolean);
                  return `${losArray.join(", ")} Day${losArray.length > 1 ? "s" : ""}`;
                })()
              : "-"}
          </span>
        </h5>
      ) : ""}

      {/* Cabin Class */}
      {form2Details?.cabinClass ? (
        <h5>
          <span className="detailslabel">Cabin class :</span>
          <span className="labelvalue">{form2Details?.cabinClass === "Business" ? "Business Class" : form2Details?.cabinClass}</span>
        </h5>
      ) : ""}

      {/* PAX */}
      {form2Details?.adults ? (
        <h5>
          <span className="detailslabel">PAX :</span>
          <span className="labelvalue">{form2Details?.adults} Adult{form2Details?.adults > 1 ? "s" : isValue?.emptyString} {form2Details?.infants !== "" && form2Details?.infants && form2Details?.infants > 0 ? `and ${form2Details?.infants} Infant${form2Details?.infants > 1 ? "s" : isValue?.emptyString}` : ""}
          </span>
        </h5>
      ) : ""}

      {/* POS */}
      {form2Details?.pos ? (
        <h5>
          <span className="detailslabel">POS :</span>
          <span className="labelvalue">{form2Details?.pos}</span>
        </h5>
      ) : ""}

      {/* Currency */}
      {form2Details?.currency ? (
        <h5>
          <span className="detailslabel">Currency :</span>
          <span className="labelvalue">{form2Details?.currency}</span>
        </h5>
      ) : ""}

      {/* Stop */}
      {form2Details?.maxStops ? (
        <h5>
          <span className="detailslabel">Max Stops :</span>
          <span className="labelvalue">{form2Details?.maxStops}</span>
        </h5>
      ) : ""}

      {/* Duration */}
      {form2Details?.maxDuration ? (
        <h5>
          <span className="detailslabel">Max Duration :</span>
          <span className="labelvalue">{form2Details?.maxDuration} hours</span>
        </h5>
      ) : ""}

      {/* Horizon Day */}
      {form2Details?.horizonDays && form2Details?.horizonDays?.length ? (
        <h5>
          <span className="detailslabel">Horizon day :</span>
          <span className="labelvalue">{`${form2Details?.horizonDays.join(' ; ')}`}</span>
        </h5>
      ) : ""}

      {/* Price Evolution Horizon */}
      {form2Details?.history?.includes("yes") && form2Details?.historicalHorizon ? (
        <h5>
          <span className="detailslabel">Price Evolution Horizon :</span>
          <span className="labelvalue">{`${form2Details?.historicalHorizon} ${parseInt(form2Details?.historicalHorizon) > 1 ? "Days" : "Day"}`}</span>
        </h5>
      ) : ""}

      {/* Custom Horizon */}
      {form2Details?.customDay && form2Details?.customDay?.length ? (
        <h5>
          <span className="detailslabel">Specific Custom Horizon Days :</span>
          <span className="labelvalue">
            {form2Details?.customDay
              ?.split(',')
              ?.map(v => v.trim())
              ?.filter(v => v !== '')
              ?.sort((a, b) => a - b)
              ?.join(', ')}
          </span>
        </h5>
      ) : ""}

      {/* Horizon start - end date */}
      {form2Details?.startDate && form2Details?.endDate ? (
        <h5>
          <span className="detailslabel">Horizon start - end date :</span>
          <span className="labelvalue">{`${moment(form2Details?.startDate).format(dateFormat?.DDMMMYY)} - ${moment(form2Details?.endDate).format(dateFormat?.DDMMMYY)}`}</span>
        </h5>
      ) : ""}

      <>
        {/* form 3 */}
        {activeStep === 2 ?
          callCount && parseInt(callCount) > 0 ? (
            <h5>
              <span className="detailslabel"> Estimated Calls Count :</span>
              <span className="labelvalue">
                {Math.ceil(callCount).toLocaleString()}
              </span>
            </h5>
          ) : <h5>
            <span className="detailslabel"> Estimated Calls Count :</span>
            <span className="labelvalue">
              N/A
            </span>
          </h5>
          : ""}
        {/* Schedule */}
        {(activeStep === 2 || form3Details?.deliveryzone?.length) && form3Details?.frequency ? (
          <h5 >
            <span className="detailslabel">Schedule :</span>
            <span className="labelvalue">{`${form3Details?.frequency ? form3Details?.frequency : "Daily"
              } refresh ${form3Details?.frequency === "Weekly" ? "on" : "at"}`}</span>
          </h5>
        ) : ""}

        {/* Weekly days */}
        {form3Details?.frequency === "Weekly" && form3Details?.frequency !== "Custom" && (
          <h5 >
            <span className="detailslabel"> </span>
            <span className="labelvalue">{`${form3Details?.weekDays
              ? weekOptions
                .filter(option => form3Details?.weekDays.includes(option.value))
                .map(option => option.label)
              : isValue?.emptyString
              }`}</span>
          </h5>
        )}

        {/* Monthly days */}
        {form3Details?.frequency === "Monthly" && form3Details?.frequency !== "Custom" && (
          <h5 >
            <span className="detailslabel"> </span>
            <span className="labelvalue">{`${form3Details?.monthDaysAdd?.length > 0
              ? form3Details.monthDaysAdd
                .map((i) => {
                  const suffix =
                    i % 10 === 1 && i !== 11
                      ? 'st'
                      : i % 10 === 2 && i !== 12
                        ? 'nd'
                        : i % 10 === 3 && i !== 13
                          ? 'rd'
                          : 'th';
                  return `${i}${suffix}`;
                })
                .join(', ')
              : isValue?.emptyString
              }`}</span>
          </h5>
        )}
        {/* Custom days */}
        {form3Details?.frequency === "Custom" &&
          (
            <h5>
              <span className="detailslabel"></span>
              <span className="labelvalue">{
                form3Details?.customAdd?.length > 0 && form3Details?.customAdd.map((dc, index) => {
                  const i = dc.toString()
                  const getOrdinal = (number) => {
                    if (number % 100 >= 11 && number % 100 <= 13) {
                      return number + "th";
                    }
                    switch (number % 10) {
                      case 1:
                        return number + "st";
                      case 2:
                        return number + "nd";
                      case 3:
                        return number + "rd";
                      default:
                        return number + "th";
                    }
                  }
                  let day = typeof (i) === "number" ? i : !i?.includes("/") ? parseInt(i) : null
                  let ordinalNum = !i?.includes("/") ? getOrdinal(day) : i?.split("/")?.[0]
                  let week = typeof (i) === "string" && i.split("/")[1]
                  let strinCludesWeek = typeof (i) === "string" && i?.includes("/")
                  const daysName = strinCludesWeek ? ordinalNum.split(",")?.map(q => parseInt(q)) : []
                  const daysofweek = daysName?.length ? weekOptions
                    .filter(option => daysName?.includes(option.value))
                    .map(option => option.label) : []
                  return (
                    <ol key={index} >
                      {strinCludesWeek ?
                        <>{`${getOrdinal(week)} - Week of ${daysofweek.toString()}`}</>
                        :
                        <>{`${ordinalNum} - of the month`}</>
                      }
                    </ol>
                  )
                })
              }</span>
            </h5>
          )
        }
        {/* delivery times */}
        {form3Details?.deliveryzone?.length ? (
          <h5 >
            <span className="detailslabel"> </span>
            <div className="labelvalue ">
              <ul className="listschedule">
                {form3Details?.deliveryzone?.map(
                  (i, index) =>
                    <li key={index}>{i.startTime} {i.timeZone}</li>
                )}
              </ul>
            </div>
          </h5>
        ) : ""}

        {/* Start Date */}
        {form3Details?.startDate ? (
          <h5 >
            <span className="detailslabel"></span>
            <span className="labelvalue">{`from ${moment(form3Details?.startDate).format(dateFormat?.LL)}`}</span>
          </h5>
        ) : ""}

        {/* End Date */}
        {form3Details?.endDate ? (
          <h5 >
            <span className="detailslabel"></span>
            <span className="labelvalue">{`to ${moment(form3Details?.endDate).format(dateFormat?.LL)}`}</span>
          </h5>
        ) : ""}

      </>
    </>
  );
};

export default ShopSettings;
